import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Skeleton for the products breadcrumb (full-width). Used as the breadcrumb Suspense fallback while
 * the category tree loads on first entry / hard refresh.
 */
export const ProductsBreadcrumbSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="border-b border-gray-200 bg-white shadow-sm"><div className="px-4 py-3 sm:px-6 lg:px-8"><div className="flex items-center gap-2"><Skeleton className="h-3 w-3 rounded-sm" /><Skeleton className="hidden h-3 w-12 sm:block" /><Skeleton className="h-4 w-4 rounded-sm" /><Skeleton className="h-3 w-20" /><Skeleton className="h-4 w-4 rounded-sm" /><Skeleton className="h-3 w-24" /></div></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};

/**
 * Skeleton for the category slider (icons row). Rendered inside the products container as the slider
 * Suspense fallback while the category tree loads.
 */
export const ProductsSliderSkeleton = () => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="absolute top-0 left-2 z-10 h-26.5 w-8 rounded-md" />;
    t1 = <Skeleton className="absolute top-0 right-2 z-10 h-26.5 w-8 rounded-md" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="relative">{t0}{t1}<div className="px-14"><div className="flex gap-3 overflow-hidden pb-5">{Array.from({
            length: 8
          }).map(_temp)}</div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp(_, i) {
  return <div key={i} className="flex h-28 min-w-40 shrink-0 flex-col items-center justify-center gap-2 rounded-md border border-gray-200 bg-white p-4"><Skeleton className="h-12 w-12 rounded-lg" /><Skeleton className="h-3 w-24 rounded-sm" /></div>;
}